export enum SignStatus {
    INPROGRESS = 1,
    CANCELED = 2,
    SIGNED = 3,
    EXPIRED = 4
}
